import { SxProps, Theme } from '@mui/material/styles';

export const landingStyles = {
    hero: {
        bgcolor: 'white',
        py: { xs: 10, sm: 16, lg: 20 },
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
    } satisfies SxProps<Theme>,
    heroOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(ellipse at 60% 20%, rgba(30,58,138,0.07) 0%, transparent 70%)',
        pointerEvents: 'none',
    } satisfies SxProps<Theme>,
    heroBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        bgcolor: 'grey.100',
        borderRadius: 10,
        px: 2,
        py: 0.5,
        mb: 4,
    } satisfies SxProps<Theme>,
    heroBadgeLink: {
        color: 'primary.main',
        fontWeight: 600,
        textDecoration: 'none',
    } satisfies SxProps<Theme>,
    heroTitle: {
        fontSize: { xs: '2rem', sm: '3rem', lg: '3.75rem' },
    } satisfies SxProps<Theme>,
    heroSubtitle: {
        mt: 2,
        mb: 4,
        fontWeight: 400,
    } satisfies SxProps<Theme>,
    heroActions: {
        display: 'flex',
        justifyContent: 'center',
        gap: 2,
        flexWrap: 'wrap',
    } satisfies SxProps<Theme>,
    primaryCta: {
        px: 4,
    } satisfies SxProps<Theme>,
    featuresSection: {
        bgcolor: 'grey.50',
        py: { xs: 8, sm: 12 },
    } satisfies SxProps<Theme>,
    featuresHeader: {
        textAlign: 'center',
        mb: 6,
    } satisfies SxProps<Theme>,
    featuresGrid: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
        gap: 4,
    } satisfies SxProps<Theme>,
    featureCard: {
        p: 4,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
    } satisfies SxProps<Theme>,
    featureIcon: {
        width: 48,
        height: 48,
        bgcolor: 'primary.main',
        borderRadius: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 2,
    } satisfies SxProps<Theme>,
};
